<template>
    <component :is="getComp(tempactive)" :temdata="temdata" :isFirst="isFirst"></component>
</template>

<script>
import {getprodel} from '@/api/new'
const requireTemp = require.context('../../components/temp', false, /\.vue$/)
export default {
    data() {
        return {
            templist: [],
            tempactive: 'template2',
            temdata: {},
            isFirst: false,
            projectId: ''
        }
    },
    mounted() {
        this.projectId = this.$route.query.projectId
        this.getTemid(this.projectId)
    },
    methods: {
        loadTemp() {
            const componentemp = requireTemp.keys().map(key => requireTemp(key))
            const loadhead = componentemp.map(component => component.default)
            this.templist = loadhead
        },
        getComp(name) {
            let comp = this.templist.find(item => item.name == name)
            return comp
        },
        getTemid(id) {
            const params = {
                id: id
            }
            getprodel(params).then(res => {
                if (res.status == 200) {
                    this.tempactive = res.data.template_local_id
                    this.temdata = res.data
                    this.isFirst = this.temdata.isFirst
                    this.loadTemp()
                } else {
                    this.$router.push('/home')
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>

</style>